const updatePlay = (state = {}, action = {}) => {
    const {
        type = null,
        datasource
    } = action;
    if (type === 'dataEngine_update_response') {
        if (datasource === 'gumbo') {
            const {
                liveData: {
                    boxscore: {
                        teams: {
                            away = {},
                            home = {}
                        } = {}
                    } = {},
                    plays: {
                        allPlays = [],
                        currentPlay
                    } = {}
                } = {},
                teamMap
            } = action.data;
            return {
                ...state,
                playerMap: {
                    ...away.playerById || {},
                    ...home.playerById || {}
                },
                allPlays,
                currentPlay,
                teamMap
            };
        } else if (datasource === 'playMetrics') {
            const {
                allPlayMetrics = {}
            } = action.data;
            return {
                ...state,
                allPlayMetrics
            }
        }
    }

    return state;
};

export default updatePlay;
